import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Contact from "./pages/Contact";
import AboutUs from "./pages/AboutUs";
import Imprint from "./pages/Imprint";
import ScrollToTop from "./components/ScrollToTop";


function App() {
    return (
        <Router>
            <ScrollToTop/>
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/aboutus" element={<AboutUs />} />
                <Route path="/imprint" element={<Imprint/>}/>
            </Routes>
        </Router>
    );
}
export default App;

